export enum NotificationFields {
  notificationId = "notificationId",

  name = "name",

  createdAt = "createdAt",
  updatedAt = "updatedAt",
}
